<template>
  <el-dialog title="扫描记录" :visible.sync="visible" width="600px" @close="close">
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="工单号" prop="billNo">
        <el-input v-model="form.billNo" placeholder="请输入工单号"/>
      </el-form-item>
      <el-form-item label="工序" prop="station">
        <el-input v-model="form.station" placeholder="请输入工序"/>
      </el-form-item>
      <el-form-item label="SN号" prop="sn">
        <el-input v-model="form.sn" placeholder="请输入SN号"/>
      </el-form-item>
      <el-form-item label="创建IP地址" prop="createIpAddress">
        <el-input v-model="form.createIpAddress" placeholder="请输入创建IP地址"/>
      </el-form-item>
      <el-form-item label="结束IP地址" prop="endIpAddress">
        <el-input v-model="form.endIpAddress" placeholder="请输入结束IP地址"/>
      </el-form-item>
      <el-form-item label="工序码" prop="standardCode">
        <el-input v-model="form.standardCode" placeholder="请输入工序码"/>
      </el-form-item>
      <el-form-item label="工序名称" prop="procedureName">
        <el-input v-model="form.procedureName" placeholder="请输入工序名称"/>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input v-model="form.note" placeholder="请输入备注" type="textarea"/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "OrderConfirmationRecordEdit",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        billNo: '',
        station: '',
        sn: '',
        createIpAddress: '',
        endIpAddress: '',
        standardCode: '',
        procedureName: '',
        note: ''
      }
    };
  },
  watch: {
    data: {
      handler(newVal) {
        this.form = Object.assign({}, newVal);
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false);
      this.$refs.form.resetFields();
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form);
        }
      });
    }
  }
};
</script>